// 스토리보드 인터랙션 타이밍.
//
// 프레임 번호(홈1-N)는 이제 "정지점"이 아니라 "섹션이 들어왔는지"를 가리키는 표식일 뿐이다.
// 정지점은 화면 크기에서 실시간으로 계산한다(HomeDesktopView.vue 의 SECTIONS / stops).
// 섹션 컴포넌트는 step >= 자기 프레임 한 줄로 등장 여부를 판단한다.
// Figma 파일에는 프로토타입 전환 시간이 들어 있지 않아(get_motion_context 가 timelineDurationMs: null)
// 여기 값들은 디자인 합의로 정한 것이다. 조정은 이 파일에서만 한다.

export const TRANSITION_MS = 700 // 기본 스텝 전환
export const COOLDOWN_MS = 180 // 전환 후 트랙패드 관성 흡수

// 홈1-5: 카드 휠이 히어로 하단에서 올라오며 회전하는 진입.
// 올라오기와 회전은 반드시 같은 시간에 끝나야 한다. 회전이 먼저 끝나면
// 남은 시간 동안 위치만 미세하게 움직여서 "슬금슬금" 기어가는 것처럼 보인다.
export const HERO_WHEEL_RISE_MS = 2100 // 올라오기 (기본의 3배)
export const HERO_WHEEL_SPIN_MS = 2100 // 회전 — 올라오기와 동시에 끝난다
// 들어오면서 도는 양(3/4바퀴). 끝 자리에서 이만큼 되감은 지점에서 출발한다.
export const HERO_WHEEL_ENTER_DEG = 270
// 카드 한 칸.
export const HERO_WHEEL_SLOT_DEG = 360 / 26
// 아우라 카드가 놓인 자리. 카드는 돌면서 들어와 바로 여기서 멈춘다 —
// 예전에는 0 칸에서 멈춘 뒤 한 칸씩 10번 더 돌려 아우라를 가운데로 가져왔다.
export const HERO_WHEEL_AURA_SLOT = 5
// 멈추는 각도. -N 칸을 돌리면 N 번 카드가 가운데로 온다.
export const HERO_WHEEL_END_DEG = -HERO_WHEEL_SLOT_DEG * HERO_WHEEL_AURA_SLOT
// 출발 각도.
export const HERO_WHEEL_START_DEG = HERO_WHEEL_END_DEG + HERO_WHEEL_ENTER_DEG
export const HERO_WHEEL_ENTER_SHIFT = 557 // 히어로 하단에서 올라오는 거리
// 진입 이징. expo 계열(0.16,1,0.3,1)은 끝에서 너무 오래 기어가서 쓰지 않는다.
export const HERO_WHEEL_EASING = 'cubic-bezier(0.33, 1, 0.68, 1)' // easeOutCubic

// 참고: 예전에는 섹션별 "등장 총 시간"을 모아 두고 그만큼 스크롤을 잠갔다.
// 지금은 잠그지 않는다 — 등장 효과는 step >= N 으로 켜지는 CSS 전환이라
// 다음 섹션으로 넘어가도 알아서 끝까지 간다(useStepScroll 참고).
// 그래서 총 시간 상수는 화면이 직접 쓰는 것만 남겼다.

// ── 인트로 ──────────────────────────────────────────────────────────
// 인트로는 스크롤 이벤트가 아니다. 화면이 로딩되면 자동으로 쭉 이어서 재생된다.
// 스크롤 스텝은 인트로가 끝난 뒤부터 동작한다.
// 1 검정 → 2 배경 → 3 공용 상단 → 4 히어로 글 → 5 카드 휠(돌면서 들어와 아우라에서 멈춤)
export const INTRO_LAST_FRAME = 5

// 첫 검정 화면을 잠깐 유지한 뒤 시작
export const INTRO_START_DELAY_MS = 300

// 각 프레임에 "도달한 뒤" 다음 프레임까지 기다리는 시간.
// 주의: 대기는 그 프레임의 애니메이션이 끝날 때까지여야 한다. 한 칸이라도 밀리면
// 진입 애니메이션이 도중에 다음 목표로 덮어써져서 두 번 도는 것처럼 보인다.
const INTRO_HOLD_MS = {
  1: 700, // 배경 생성
  2: 500, // 메뉴 등장
  3: 500, // 히어로 텍스트 등장
  4: 300, // 텍스트를 잠깐 보여주고 휠 진입 시작
}

export const introHoldAfterFrame = (frame) => INTRO_HOLD_MS[frame] ?? 600

// ── 섹션 내부 텍스트 등장 ───────────────────────────────────────────
// 스크롤이 끝나자마자 효과가 시작되면 이동과 겹쳐서 산만하다.
// 스크롤 전환이 끝나고 잠시 멈춘 뒤에 시작한다.
export const SECTION_REVEAL_PAUSE_MS = 250
export const SECTION_REVEAL_DELAY_MS = TRANSITION_MS + SECTION_REVEAL_PAUSE_MS

// 자유 스크롤 화면(home2)에서 쓰는 지연.
//
// 위의 SECTION_REVEAL_DELAY_MS 는 TRANSITION_MS(700) 를 더해 둔다. 옛 화면은 스텝마다
// 700ms 동안 화면을 밀어 올렸고, 그 이동이 끝나기를 기다리려는 값이었다.
// 새 화면은 native 스크롤이라 기다릴 전환이 없다 - 남은 700 은 죽은 값이다.
//
// 그 700 때문에 원인과 결과가 끊어져 보였다. 눈금선을 지나 연출이 켜져도 글은
// 0.95 초 뒤에 올라오는데, 그 사이에 스크롤을 되올리면 위로 올려서 글이 나온 것처럼
// 보인다(2026-09-26 제보). 쉼만 남기면 지나자마자 올라온다.
//
// 2026-09-30 에 남은 쉼 250 도 0 으로 내렸다("대기시간을 우선 0으로 해보자").
// 연출은 스크롤을 잠그지 않아서, 켜지는 순간과 글이 다 서는 순간 사이에 화면이
// 계속 지나간다 - 250 을 없애면 그 간격이 1.65 초에서 1.40 초가 된다.
//
// SECTION_REVEAL_PAUSE_MS 는 그대로 둔다. 그 값은 옛 화면(/legacy)의 components/home
// 쪽이 SECTION_REVEAL_DELAY_MS 로 쓰고 있어서, 같이 내리면 안 보는 화면까지 바뀐다.
// 되돌릴 때는 이 줄만 SECTION_REVEAL_PAUSE_MS 로 되돌리면 된다.
export const SCENE_REVEAL_DELAY_MS = 0

// 새 화면의 글 등장은 두 단계다(2026-09-26 요청).
//   0 눈썹 + 제목(모든 줄) 한꺼번에
//   1 서브 텍스트와 그 아래 딸린 것들
// 첫 섹션(스테이트먼트)이 이미 이 모양이고 나머지를 거기에 맞췄다.
// 섹션마다 2 · 4 · 5 · 5 · 5 · 4 단계로 제각각이던 것을 둘로 모은 것이다.
// 400 이다. 서브는 제목이 다 서기 전에 시작해 부드럽게 이어져야 한다(2026-09-27).
//
// 이징 (0.16,1,0.3,1)이 앞쪽에 몰려 있어 값을 눈으로 가늠하기 어렵다.
// 서브가 시작하는 순간 제목이 어디까지 가 있는지로 보면 이렇다.
//   180  58%   둘이 한참 같이 움직인다 - 동시로 보인다
//   400  89%   제목이 마지막을 마무리하는 중에 서브가 뜬다 - 이어진다
//   600  96%   제목이 이미 멈춘 뒤다 - 끊겨 보인다
// 180 과 600 을 차례로 겪고 그 사이로 잡은 값이다.
// 2026-09-30 에 400 -> 560 으로 늘렸다. 아래 SCENE_TEXT_MS 를 1.4 배 할 때
// 이 값도 같은 비율로 올려야 "제목이 89% 갔을 때 서브가 뜬다" 는 관계가
// 유지된다(560/1400 = 400/1000).
export const SCENE_TEXT_STAGGER_MS = 560
// 두 번째 단계(서브 텍스트)가 시작하는 때. 글이 다 뜨는 때가 아니다.
export const SCENE_TEXT_SUB_MS = SCENE_REVEAL_DELAY_MS + SCENE_TEXT_STAGGER_MS

// 글 한 덩어리가 드러나는 모양. 모든 섹션이 이 하나를 쓴다(2026-09-26 요청).
//
// 첫 섹션이 쓰던 것이다 - 덩어리 높이만큼 아래에서 밀어 올리고 상자 밖은 잘라 둔다.
// 흐려졌다 진해지는 페이드는 쓰지 않는다.
//
// 예전에는 섹션마다 달랐다. 전부 700ms 인데도 속도가 달라 보인 이유다.
//   이징 (0.16,1,0.3,1) 대 (0.33,1,0.68,1) · 거리 110% 대 40~80px
//   방식 마스크 슬라이드 · clip-path 와이프 · 투명도 페이드
//
// 1000 이다. 700(TRANSITION_MS)이었는데 첫 섹션 글이 너무 빨리 지나간다는 제보로
// 늦췄다(2026-09-27). 모든 섹션이 이 하나를 쓰므로 전부 같이 느려진다 - 첫 섹션에
// 맞추기로 한 2026-09-26 결정 그대로다. 속도만 바꾸는 것이라 나오는 차례(아래
// STAGGER)는 건드리지 않았다.
// 2026-09-30 에 1000 -> 1400 으로 늦췄다("전체적으로 텍스트가 보여지는
// 애니메이션의 속도가 너무 빠르다"). 700 -> 1000 에 이어 두 번째다.
// 모든 섹션이 이 하나를 쓰므로 전부 같이 느려진다.
export const SCENE_TEXT_MS = 1400
export const SCENE_TEXT_EASE = 'cubic-bezier(0.16, 1, 0.3, 1)'

// 글이 아니라 통째로 미끄러져 들어오는 것들(앱 폰 목업, 비전 연결선)의 길이.
// 예전에는 TRANSITION_MS(700)를 같이 썼는데, 그 값은 히어로 인트로가
// INTRO_HOLD_MS 와 물려 쓰고 있어 같이 늘리면 인트로 사슬이 어긋난다
// (주석: "대기는 그 프레임의 애니메이션이 끝날 때까지여야 한다").
// 그래서 2026-09-30 에 갈라 냈다. 700 x 1.4 = 980.
export const SCENE_APPEAR_MS = 980

// ── 섹션을 나누는 줄 ─────────────────────────────────────────────────
// 가운데에서 양끝으로 펼쳐진다(scaleX).
//
// 글과 다른 값을 쓴다. 글의 이징(0.16,1,0.3,1)은 앞쪽에 몰려 있어 0.3 초면 82% 를
// 가는데, 덩어리가 미끄러지는 글에는 맞아도 선이 그어지는 데는 "확 뻗고 멈칫" 으로
// 보인다(2026-09-27 제보: 너무 빠르다). 고른 곡선으로 길게 긋는다.
export const DIVIDER_DRAW_MS = 1400
export const DIVIDER_DRAW_EASE = 'cubic-bezier(0.33, 1, 0.68, 1)'

// 줄이 창에 들어온 뒤 얼마나 더 내려가야 펼치나. 스크롤 한 칸이다(윈도우 기준 100px).
//
// 창 아랫변에 닿자마자 펼치면 화면 맨 아래 가장자리에서 도는 셈이라 안 보이고,
// 볼 수 있는 자리 한가운데까지 기다리면 너무 늦다(2026-09-27). 앞 섹션 연출이
// 끝나고 한 번 더 굴렸을 때 줄이 그어지는 자리다.
export const DIVIDER_LEAD_PX = 100

// order 0 = 뱃지 + 제목, 1 = 서브 텍스트.
// translateProp: 비전처럼 인라인 transform 을 못 쓰는 곳은 translate 속성으로 준다
// (transform 을 인라인으로 쓰면 -translate-x-1/2 클래스가 통째로 덮어써진다).
export const sceneTextReveal = (on, order, { translateProp = false } = {}) => ({
  clipPath: on ? 'inset(0 0 0 0)' : 'inset(100% 0 0 0)',
  ...(translateProp
    ? { translate: on ? 'none' : '0 100%' }
    : { transform: on ? 'translateY(0)' : 'translateY(100%)' }),
  transitionProperty: translateProp ? 'clip-path, translate' : 'clip-path, transform',
  transitionTimingFunction: SCENE_TEXT_EASE,
  transitionDuration: `${SCENE_TEXT_MS}ms`,
  transitionDelay: on ? `${SCENE_REVEAL_DELAY_MS + order * SCENE_TEXT_STAGGER_MS}ms` : '0ms',
})

// 스테이트먼트 섹션 (홈1-16): 5줄이 위에서부터 순서대로 역커튼으로 올라온다.
export const STATEMENT_LINE_STAGGER_MS = 180
export const STATEMENT_LINE_COUNT = 5
// ── 신뢰지표 섹션 (홈1-21) ──────────────────────────────────────────
// 홈1-21 에 도착하면 자동으로 이어지는 시퀀스:
//   ① 첫 카드가 정사각형으로 가운데 등장
//   ② 나머지 5장이 오른쪽에서 같은 크기로 날아와 위에 겹침
//   ③ 다 모이면 잠깐 멈춤
//   ④ 직사각형으로 변형
//   ⑤ 최종 위치로 펼쳐짐
export const TRUST_CARD_SQUARE_W = 676 // 겹쳐 있을 때 (정사각형)
export const TRUST_CARD_FINAL_W = 282 // 최종 (직사각형)
// 대기 위치는 화면 밖이 아니다. 스토리보드 실측:
//   대기 x=1307(너비 676) → 도착 x=622.
//   첫 카드의 오른쪽 끝이 622+676=1298 이므로 바로 그 옆에 붙어서 대기한다.
//   단, 첫 카드(거래액)는 홈1-19/20/21 내내 x=622 로 고정이라 이동하지 않고 제자리에서 나타난다.
//   중심 기준 오프셋 = (1307+338) - 960 = 685
export const TRUST_CARD_ENTER_X = 685

// 대기 중인 카드가 첫 카드 오른쪽 바깥에 그대로 보이면 "밖에서 날아오는" 것처럼 보인다.
// 카드 묶음의 오른쪽 끝(page x=1298 = 첫 카드의 오른쪽 끝)에서 컨테이너를 잘라두면,
// 대기 카드는 완전히 가려져 있다가 그 경계를 넘어오면서 조금씩 드러난다.
// 카드와 배경 사이에서 빠져나오는 것처럼 보이게 하는 장치다.
// 컨테이너(4133:20506)는 page x 64~1856(너비 1792)이므로 오른쪽 inset = 1792-(1298-64) = 558.
export const TRUST_STACK_CLIP_RIGHT = 558
export const TRUST_CARD_OFFSETS = [-755, -453, -151, 151, 453, 755] // 최종 중앙 기준 오프셋

// 머리말(눈썹 · 제목 · 설명)이 차례로 올라오는 간격.
// 다른 섹션들과 같은 값이다 - 거래소개 · 미디어 · 앱 · 비전 모두 180 이다.
export const TRUST_HEAD_STAGGER_MS = 180
// 2026-09-26 에 박자를 줄였다. 350/600/700/700 이면 트리거부터 펼침까지 3.29 초인데,
// 그 사이 스크롤을 계속하면 한참 내려간 자리에서 카드가 펼쳐져 "늦게 시작한다" 로
// 보였다. 그래서 200/300/500/500(2.30 초)로 줄였다.
//
// 2026-09-27 에 "살짝만 느리게" 요청으로 각 값을 1.25 배 했다. 2.30 -> 2.87 초다.
// 늦어 보이던 3.29 초보다는 분명히 아래에 둔다.
export const TRUST_CARD_STAGGER_MS = 250 // 카드 한 장씩 날아오는 간격
export const TRUST_GATHER_PAUSE_MS = 380 // 다 모인 뒤 멈춤
export const TRUST_MORPH_MS = 620 // 정사각형 → 직사각형
export const TRUST_SPREAD_MS = 620 // 최종 위치로 펼치기

// ── 거래 소개 섹션 (홈1-30) ─────────────────────────────────────────
// 이미지와 텍스트가 위에서부터 순서대로 아래에서 위로 드러난다(역커튼).
// 이동 거리는 스토리보드 실측값 (홈1-30 → 홈1-31):
//   사진 -50, 헤드라인 1행 -60, 2행 -60, 본문 -50.
// 뱃지·구분선·인증 블록은 좌표가 같아 위치는 안 움직이지만,
// 홈1-30 에서는 보이지 않다가 등장하므로 같은 효과로 함께 나타나야 한다(사용자 확인).
export const TRADING_ITEM_STAGGER_MS = 180
export const TRADING_ITEMS = [
  { node: '4133:20689', order: 0, rise: 50 }, // 메인 사진
  { node: '4133:20690', order: 1, rise: 50 }, // Real Gold Market 뱃지
  { node: '4133:20692', order: 2, rise: 60 }, // 국내 최고 품질의
  { node: '4133:20694', order: 3, rise: 60 }, // 안전한 금,은 거래
  { node: '4133:20696', order: 4, rise: 50 }, // 본문 + 버튼
  { node: '4133:20738', order: 5, rise: 50 }, // 구분선
  { node: '4133:20716', order: 6, rise: 50 }, // 글로벌/국내 인증 라벨 + 로고 이미지
]
// ── 미디어 허브 섹션 (홈1-33) ───────────────────────────────────────
// 스토리보드: 33 도착 → 34 좌측 텍스트 → 35 유튜브 로고 → 36 썸네일 9장.
// 위에서부터 순서대로 아래에서 위로 드러난다(역커튼).
export const MEDIA_ITEM_STAGGER_MS = 180
export const MEDIA_ITEM_COUNT = 6
// 유튜브 로고와 썸네일 9장은 세로 커튼이 아니라 가로로 들어오며 페이드된다.
//   유튜브 로고 : 왼쪽 → 오른쪽
//   썸네일 9장  : 오른쪽 → 왼쪽
export const MEDIA_SLIDE_MS = 980 // 유튜브 로고 (2026-09-30: 700 x 1.4)
export const MEDIA_THUMBS_SLIDE_MS = 1260 // 썸네일 그리드 (2026-09-30: 900 x 1.4)
// 이동 거리는 추측이 아니라 스토리보드 실측값이다.
// 유튜브 로고: 홈1-34 x=115 → 홈1-35 x=215 (왼쪽에서 +100)
// 썸네일:     홈1-35 x=1507 → 홈1-36 x=1407 (오른쪽에서 -100)
export const MEDIA_LOGO_SLIDE_PX = -100 // 음수 = 왼쪽에서 들어옴
export const MEDIA_THUMBS_SLIDE_PX = 100 // 양수 = 오른쪽에서 들어옴
export const MEDIA_REVEAL_TOTAL_MS =
  SECTION_REVEAL_DELAY_MS + (MEDIA_ITEM_COUNT - 1) * MEDIA_ITEM_STAGGER_MS + MEDIA_THUMBS_SLIDE_MS

// 미디어 허브 썸네일 9칸에서 재생할 유튜브 영상.
// 순서는 그리드 읽는 순서 (1행 좌→우, 2행, 3행).
export const MEDIA_VIDEO_IDS = [
  'HZ1aCuE-TU0',
  '-CszsXQ2U7Y',
  'gWUkxFriSTg',
  'htGRJbAAlis',
  'n2tzmHlIifI',
  'VEAuzYeJs68',
  'd5CTlFqQxsw',
  '-pdOrpGdB_c',
  'S5yQAJC-Kkk',
]

// ── 앱 소개 섹션 (홈1-37) ───────────────────────────────────────────
// 스토리보드: 37 도착 → 38 좌측 텍스트 → 39 폰 목업.
// 좌표 실측:
//   헤드라인 3줄  홈1-37 y=537 → 홈1-38 y=457  (-80, 아래에서 위로)
//   폰 목업      홈1-38 x=889 → 홈1-39 x=789  (-100, 오른쪽에서 왼쪽으로)
//   뱃지·AUGO·스토어 버튼은 좌표가 같아 투명도로만 등장한다.
export const APP_ITEM_STAGGER_MS = 180
export const APP_PHONE_SLIDE_PX = 100 // 양수 = 오른쪽에서 들어옴
export const APP_ITEMS = [
  { node: '4133:20305', order: 0 }, // Real Gold Trade 뱃지
  { node: '4133:20307', order: 1, rise: 80 }, // 헤드라인 3줄
  { node: '4133:20314', order: 2 }, // Real Money is Real Gold Trad / AUGO
  { node: '4133:20319', order: 3 }, // App Store / Google Play
  { node: '4133:20340', order: 4, slideX: APP_PHONE_SLIDE_PX }, // 폰 목업
]
// ── 비전 2027 섹션 (홈1-42 하나로 통합) ─────────────────────────────
// 스토리보드는 홈1-40에서 헤더, 홈1-42에서 카드로 정지점이 나뉘어 있었다.
// 그러면 텍스트만 보고 한 번 더 스크롤해야 카드가 올라와서 흐름이 끊긴다.
// 비전 섹션은 Figma 원본 높이 1116px와 섹션 시작점 6501px을 그대로 사용한다.
// 이 위치면 헤더와 카드의 최종 좌표가 Figma 프레임과 일치한다.
//   헤더 등장 → 이어서 카드/연결선 6단계가 한 시퀀스로 진행된다.
//     42 카드1(20조) → 43 연결선(x452) → 44 카드2(Vision 2027)+RWA/STO
//     → 45 연결선(x960) → 46 카드3(367조) → 47 연결선(x1470)
// 화살표 8개는 스토리보드(4133:* 세대)에 없는 신규 요소라 등장 시점 근거가 없다.
// 사용자 결정으로 연결선 x960(beat 3)과 같은 타이밍에 제자리 페이드시킨다.
// 배경 곡선과 글로우는 홈1-40 부터 이미 보이므로 애니메이션하지 않는다.
export const VISION_HEAD_STAGGER_MS = 180
export const VISION_HEAD_ITEMS = [
  { node: '4133:20642', order: 0 }, // Beyond Gold & Silver 뱃지
  { node: '4133:20640', order: 1, rise: 80 }, // 금·은 시장은 새로운 자산 생태계로
  { node: '4133:20645', order: 2, rise: 80 }, // 변화의 시대를 맞이하고 있습니다.
  { node: '4133:20644', order: 3 }, // RWA·STO 본문 3줄
]
// 카드 3장은 모두 섹션 좌표 y=1176(뷰포트 바로 아래)에서 출발해 제자리로 올라온다.
// 실측: 카드1 -364, 카드2 -479, 카드3 -792 = 1176 - 각자의 최종 top.
// 연결선 3개는 이동 없이 페이드만 한다.
export const VISION_CARD_START_Y = 1176
// 2026-09-30 에 400 -> 900 으로 되돌렸다. 900 이 원래 값이었는데 굼떠
// 보인다고 줄였던 것을, 다시 그 속도로 해 달라는 요청을 받았다.
// 카드끼리의 터울은 아래 STAGGER 쪽이고 그대로 둔다.
export const VISION_CARD_RISE_MS = 900
export const VISION_BUILD_STAGGER_MS = 200
export const VISION_BUILD_BEATS = [
  { beat: 0, rise: 364 }, // 카드1 국내 금·은 시장 규모 / 20조   (top 812)
  { beat: 1, rise: 0 }, //   연결선 x452
  { beat: 2, rise: 479 }, // 카드2 Vision 2027 + RWA/STO       (top 697)
  { beat: 3, rise: 0 }, //   연결선 x960 + 골드 화살표 8개(391:340)
  { beat: 4, rise: 792 }, // 카드3 국내 RWA 시장 규모 / 367조    (top 384)
  { beat: 5, rise: 0 }, //   연결선 x1470
]
// 카드는 머리말의 마지막 줄(RWA·STO 본문)이 뜨기 시작할 때 같이 올라온다.
// 예전에는 머리말이 다 끝난 뒤(VISION_HEAD_TOTAL_MS = 2190ms)였는데, 그 사이가 비어 보였다.
// 본문이 시작하는 1490ms 에 맞추면 작은 글씨가 드러나는 동안 박스가 올라온다(사용자 요청).
// 차이는 마지막 줄의 전환 시간(TRANSITION_MS 700ms)만큼이다.
export const VISION_BUILD_START_MS =
  SECTION_REVEAL_DELAY_MS + (VISION_HEAD_ITEMS.length - 1) * VISION_HEAD_STAGGER_MS
